import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";
export const Category = ({ category }: SpecProps<"category">) => {
  const { i18n } = useLingui();

  if (!category) {
    return null;
  }
  const field = i18n.t({
    id: "itemPageLayout.common.category",
    message: "Category",
    comment: "Label for category",
  });

  return <FieldValuePair field={field} value={category} />;
};
